import { Routes } from '@angular/router';

import { authGuard } from './core/guards/auth.guard';
import { noAuthGuard } from './core/guards/no-auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    canActivate: [noAuthGuard],
    loadComponent: () =>
      import('./features/auth/auth-layout/auth-layout.component').then((m) => m.AuthLayoutComponent),
    children: [
      {
        path: 'login',
        loadComponent: () => import('./features/auth/login/login.component').then((m) => m.LoginComponent)
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./features/auth/forgot-password/forgot-password.component').then(
            (m) => m.ForgotPasswordComponent
          )
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('./features/auth/reset-password/reset-password.component').then(
            (m) => m.ResetPasswordComponent
          )
      },
      {
        path: 'set-password',
        loadComponent: () =>
          import('./features/auth/reset-password/reset-password.component').then(
            (m) => m.ResetPasswordComponent
          )
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'login'
      }
    ]
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/admin/admin-layout/admin-layout.component').then((m) => m.AdminLayoutComponent),
    children: [
      {
        path: 'applicants',
        loadComponent: () =>
          import('./features/admin/applicants/applicants.component').then((m) => m.ApplicantsComponent)
      },
      {
        path: 'state-flows',
        loadComponent: () =>
          import('./features/admin/state-flows/state-flows.component').then((m) => m.StateFlowsComponent)
      },
      {
        path: 'state-flows/:stateCode',
        loadComponent: () =>
          import('./features/admin/state-flow-builder/state-flow-builder.component').then((m) => m.StateFlowBuilderComponent)
      },
      {
        path: 'requirements-library',
        loadComponent: () =>
          import('./features/admin/requirements-library/requirements-library.component').then((m) => m.RequirementsLibraryComponent)
      },
      {
        path: 'review-queue',
        loadComponent: () =>
          import('./features/admin/review-queue/review-queue.component').then((m) => m.ReviewQueueComponent)
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'applicants'
      }
    ]
  }
];
